.stretched {
  label {
    width: 100%;
  }
}